import {
  CONVERT_MEASURES,
  CONVERT_SYSTEMS,
  UNITS_BY_CATEGORY,
  USE_PROJECT_DEFAULT_UNIT_SYSTEM,
} from 'app/app.constants';

const units = {
  top: UNITS_BY_CATEGORY[CONVERT_MEASURES.DEPTH][CONVERT_SYSTEMS.METRIC],
  bottom: UNITS_BY_CATEGORY[CONVERT_MEASURES.DEPTH][CONVERT_SYSTEMS.METRIC],
  length: UNITS_BY_CATEGORY[CONVERT_MEASURES.LENGTH][CONVERT_SYSTEMS.METRIC],
  toolDia:
    UNITS_BY_CATEGORY[CONVERT_MEASURES.TOOL_DIAMETER][CONVERT_SYSTEMS.METRIC],
  tubDia:
    UNITS_BY_CATEGORY[CONVERT_MEASURES.TUBULAR_DIAMETER][
      CONVERT_SYSTEMS.METRIC
    ],
  depth: UNITS_BY_CATEGORY[CONVERT_MEASURES.DEPTH][CONVERT_SYSTEMS.METRIC],
  weight: UNITS_BY_CATEGORY[CONVERT_MEASURES.MASS][CONVERT_SYSTEMS.METRIC],
};

const unitsFromWellbore = (wellbore) => {
  const out = {};
  const want = { length: true, depth: true, tubDia: true, toolDia: true };
  const stack = [wellbore];
  const seen = new WeakSet();

  while (
    stack.length &&
    (want.length || want.depth || want.tubDia || want.toolDia)
  ) {
    const n = stack.pop();
    if (!n || typeof n !== 'object' || seen.has(n)) continue;
    seen.add(n);

    for (const k in n) {
      if (!Object.prototype.hasOwnProperty.call(n, k)) continue;
      const v = n[k];
      if (!v || typeof v !== 'object') continue;

      if (want.depth && (k === 'top' || k === 'bottom')) {
        const u = v.unit;
        if (u != null) {
          out.depth = u;
          out.top = u;
          out.bottom = u;
          want.depth = false;
        }
        continue;
      }

      if ((want.tubDia || want.toolDia) && k === 'innerDiameter') {
        const u = v.unit;
        if (u != null) {
          if (want.tubDia) {
            out.tubDia = u;
            want.tubDia = false;
          }
          if (want.toolDia) {
            out.toolDia = u;
            want.toolDia = false;
          }
        }
        continue;
      }

      if (want.length && k === 'length') {
        const u = v.unit;
        if (u != null) {
          out.length = u;
          want.length = false;
        }
        continue;
      }

      stack.push(v);
    }
  }

  return out;
};

export const wellSectionUoM = (unitSystem, selectedUnits, wellbore) => {
  if (unitSystem === undefined) return units;

  if (unitSystem === USE_PROJECT_DEFAULT_UNIT_SYSTEM) {
    const found = unitsFromWellbore(wellbore);
    return { ...units, ...found };
  }

  units['top'] =
    UNITS_BY_CATEGORY[CONVERT_MEASURES.LENGTH][
      unitSystem === CONVERT_SYSTEMS.METRIC ||
      unitSystem === CONVERT_SYSTEMS.IMPERIAL
        ? unitSystem
        : selectedUnits.depth
    ];

  units['bottom'] =
    UNITS_BY_CATEGORY[CONVERT_MEASURES.LENGTH][
      unitSystem === CONVERT_SYSTEMS.METRIC ||
      unitSystem === CONVERT_SYSTEMS.IMPERIAL
        ? unitSystem
        : selectedUnits.depth
    ];

  units['length'] =
    UNITS_BY_CATEGORY[CONVERT_MEASURES.LENGTH][
      unitSystem === CONVERT_SYSTEMS.METRIC ||
      unitSystem === CONVERT_SYSTEMS.IMPERIAL
        ? unitSystem
        : selectedUnits.length
    ];

  units['depth'] =
    UNITS_BY_CATEGORY[CONVERT_MEASURES.LENGTH][
      unitSystem === CONVERT_SYSTEMS.METRIC ||
      unitSystem === CONVERT_SYSTEMS.IMPERIAL
        ? unitSystem
        : selectedUnits.depth
    ];

  units['toolDia'] =
    UNITS_BY_CATEGORY[CONVERT_MEASURES.TOOL_DIAMETER][
      unitSystem === CONVERT_SYSTEMS.METRIC ||
      unitSystem === CONVERT_SYSTEMS.IMPERIAL
        ? unitSystem
        : selectedUnits.toolDiameter
    ];
  units['tubDia'] =
    UNITS_BY_CATEGORY[CONVERT_MEASURES.TUBULAR_DIAMETER][
      unitSystem === CONVERT_SYSTEMS.METRIC ||
      unitSystem === CONVERT_SYSTEMS.IMPERIAL
        ? unitSystem
        : selectedUnits.tubularDiameter
    ];

  units['weight'] =
    UNITS_BY_CATEGORY[CONVERT_MEASURES.MASS][
      unitSystem === CONVERT_SYSTEMS.METRIC ||
      unitSystem === CONVERT_SYSTEMS.IMPERIAL
        ? unitSystem
        : selectedUnits.mass
    ];

  return units;
};
